import { Component, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "@app/shared/auth.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-change-password",
  templateUrl: "./change-password.component.html",
  styleUrls: ["./change-password.component.sass"],
})
export class ChangePasswordComponent implements OnInit {
  @ViewChild("changePasswordModal") searchModal;
  closeResult: any;

  formGroup: FormGroup;

  constructor(
    private modalService: NgbModal,
    private authService: AuthService,
    public toasterService: ToastrService
  ) {}

  ngOnInit(): void {
    this.intializeForm();
  }

  intializeForm(){
    this.formGroup = new FormGroup({
      oldPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(40),
        // Validators.pattern(
        //   "(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@$!%*?&])[A-Za-zd@$!%*?&]{6,40}"
        // ),
      ]),
      password: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(40),
        Validators.pattern(
          "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@$!%*?&]).{6,}$"
        ),
      ]),
      confirmPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(40),
        Validators.pattern(
            "^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[@$!%*?&]).{6,}$"
        ),
      ]),
    });
  }

  open() {
    this.intializeForm();
    this.modalService
      .open(this.searchModal, {
        size: "md",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  getDismissReason(reason: any) {
    throw new Error("Method not implemented.");
  }
  loading: boolean = false;
  changePassword() {
    this.loading = true;
    this.authService.changePassword(this.formGroup.getRawValue()).subscribe(
      (res) => {
        if (res.errors) {
          this.toasterService.error(
            res?.errors[0]?.message
              ? res?.errors[0]?.message
              : "Some error occured",
            "Error",
            {
              positionClass: "toast-top-right",
            }
          );
        } else {
          this.toasterService.success(res?.msg, "Success", {
            positionClass: "toast-top-right",
          });
          this.modalService.dismissAll();
        }
        this.loading = false;
      },
      (err) => {
        //console.log("Some error occured");
        this.toasterService.error(
          err?.errors[0]?.message
            ? err?.errors[0]?.message
            : "Some error occured",
          "Error",
          {
            positionClass: "toast-top-right",
          }
        );
        this.loading = false;
      }
    );
  }
}
